import { uniq } from 'lodash'

// 将时间字符串转换为分钟表示
const toMinutes = (timeStr) => {
  const [hours, minutes] = timeStr.split(':').map(Number)
  return hours * 60 + minutes
}

function checkTimeIntervals (arr, threshold) {
  // 验证时间间隔是否超过阈值
  for (let i = 1; i < arr.length; i++) {
    const currentTime = toMinutes(arr[i])
    const prevTime = toMinutes(arr[i - 1])
    const interval = (currentTime - prevTime) * 60

    if (interval < threshold) {
      return false
    }
  }

  return true
}

export default {
  methods: {
    checkTimeIntervals (times) {
      return checkTimeIntervals(times, 60 * 60)
    },
    sortUniq (times) {
      return uniq(times).sort()
    }
  }
}
